import { Component, OnInit, Input } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-call-item-operator',
  templateUrl: './list-call-item-operator.component.html',
  styleUrls: ['./list-call-item-operator.component.scss']
})
export class ListCallItemOperatorComponent implements OnInit {
  @Input() calls: Call[];

  public displayedColumns: string[] = [
    'number', 'status', 'priority', 'business', 'business_user', 'user', 'type', 'open_since', 'options'
  ];

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public classesByState(call: Call): string {
    switch (call.status) {
      case 'T': return 'bg-attending';
      case 'P': return 'bg-pending';
      case 'R': return 'bg-solved';
      case 'F': return 'bg-closed';
      case 'C': return 'bg-canceled';
      default: return 'bg-waiting';
    }
  }

  public goToCall(call: Call) {
    this.router.navigate([`/operador/chamados/${ call.identifier }`])
  }

  public getShowName(name): string {
    let user = name.split(' ');
    return user[0]
  }

}
